import { request } from "../../api/api";

export const getRobotHistory = (params) => {
  return request.post(`getRobotHistory/`, params);
};

export const updateRobotParametersStatus = (params) => {
  return request.post(`updateRobotParametersStatus/`, params);
};

export const abortBatch = (params) => {
  return request.post(`abortBatch/`, params);
};
export const updateRemarks = (params) => {
  return request.post(`dipping_parameter/updateRemarks/`, params);
};

export const filterUid = (params) => {
  console.log("filter_search   &page=${params.page+1} ", params);
  return request.post(
    `filter_search/?search=${params.uid_type}&page=${params.page + 1}`
  );
};

export const exportExcel = (params) => {
  return request.post(`exportDippingParameter/`, params);
};

export const autoAddBatch = (params) => {
  return request.post(`dipping_parameter/autoAddBatch/`, params);
};

export const checkbatchstatus = (params) => {
  return request.post(`checkbatchstatus/`, params);
};

export const getAutoBatchHistory = (params) => {
  let queryParams = [
    params.search.Date ? `search=${params.search.Date}` : "",
    params.search.Time ? `created_at__time=${params.search.Time}` : "",
    params.search.Batch_No ? `batch_type=${params.search.Batch_No}` : "",
    params.search.Shift ? `shift__shift_name=${params.search.Shift}` : "",
  ]
    .filter((param) => param !== "")
    .join("&");
  return request.get(
    `dipping_parameter/getAutoBatchHistory/?${queryParams}&${
      params.rowsPerPage ? `page_size=${params.rowsPerPage}` : ""
    }&page=${params.page + 1}`
  );
};
export const abortBatchDataAPI = (params) => {
  return request.post(`abortBatch/`, params);
};
export const getTopicDetails = (params) => {
  return request.get(`dipping_parameter/getTopicDetails/`, params);
};
export const triggerRobotStatus = (params) => {
  return request.post(`dipping_parameter/triggerRobotStatus/`, params);
};

export const getDippingParameterBatch = (searchParams) => {
  let queryParams = [
    searchParams.search.Date ? `search=${searchParams.search.Date}` : "",
    searchParams.search.B_No ? `batch_type=${searchParams.search.B_No}` : "",
    searchParams.search.Lot_No
      ? `lot_number=${searchParams.search.Lot_No}`
      : "",
    searchParams.search.Scre ? `scre=${searchParams.search.Scre}` : "",
    searchParams.search.Class
      ? `class_id__class_name=${searchParams.search.Class}`
      : "",
    searchParams.search.Size
      ? `size__size_name=${searchParams.search.Size}`
      : "",
    searchParams.search.LR ? `r_or_l=${searchParams.search.LR}` : "",
    searchParams.start_datetime
      ? `start_datetime=${searchParams.start_datetime}`
      : "",
    searchParams.end_datetime
      ? `end_datetime=${searchParams.end_datetime}`
      : "",

    searchParams.search.cycle_status
      ? `dipping_count=${searchParams.search.cycle_status}`
      : "",
    searchParams.search.cycle_count
      ? `no_of_dipping=${searchParams.search.cycle_count}`
      : "",
  ]
    .filter((param) => param !== "")
    .join("&");

  return request.get(
    `getDippingParameterBatch/?${queryParams}&${
      searchParams.rowsPerPage ? `page_size=${searchParams.rowsPerPage}` : ""
    }&page=${searchParams.page + 1}`
  );
};
export const getRobotStatusDataAPI = () => {
  return request.get(`getRobotStatus/`);
};


export const addAlarmNote =(params)=>{
  return request.post("addAlarmNote/",params)
}
export const getAlarms = (params, searchalarm, page, pageSize) => {
  console.log("paramssadasdasd", params);
  const queryParams = {
    page: page + 1,
    page_size: pageSize,
    created_at__date: searchalarm.date,
    tag: searchalarm.tag,
    alarm_message: searchalarm.alarm_msg,
    search: searchalarm.time,
    state: searchalarm.state,
    acknowledge: searchalarm.is_action,
    is_noted : searchalarm.is_noted,
    ...params
  };
  const filteredParams = Object.entries(queryParams)
    .filter(([_, value]) => value)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  return request.get(`getAlarms/?${filteredParams}`);
};

export const alarmAllAction =(params)=>{
  return request.post(`allAlarmsAcknowledge/`,params)
}

export const alarmAction = (data) => {
  return request.post('alarmAcknowledge/', data)
}

export const getAlarmACKCount = () => {
  return request.get('getAlarmACKCount/')
}

export const exportAlarmWindowExcelReport = (data) => {
  return request.post('alarm/exportAlarmWindowExcelReport/',data)
}


export const createDailyParaDippingCell = (data) => {
  return request.post('dipping_parameter/createDailyParaDippingCell/',data)
}
export const getDailyParaOfDippingCellDetails = (data) => {
  return request.get('dipping_parameter/getDailyParaOfDippingCellDetails/',data)
}
export const approveDippingCell = (data) => {
  return request.post('dipping_parameter/approveDippingCell/',data)
}
export const createDailyParaCoagulant = (data) => {
  return request.post('dipping_parameter/createDailyParaCoagulant/',data)
}